// Recognisable provider marks for the "connect an account" screens (drawn inline; no network requests).
type P = { className?: string };

export function GmailLogo({ className = 'h-8 w-8' }: P) {
  return (
    <svg viewBox="52 42 88 66" className={className} aria-hidden>
      <path fill="#4285f4" d="M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6" />
      <path fill="#34a853" d="M120 108h14c3.32 0 6-2.69 6-6V59l-20 15" />
      <path fill="#fbbc04" d="M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2" />
      <path fill="#ea4335" d="M72 74V48l24 18 24-18v26L96 92" />
      <path fill="#c5221f" d="M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2" />
    </svg>
  );
}

export function GoogleG({ className = 'h-[18px] w-[18px]' }: P) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
    </svg>
  );
}

export function OutlookLogo({ className = 'h-8 w-8' }: P) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <path fill="#0A2767" d="M45 24.6a1 1 0 0 0-.5-.9l-16-9.1-.2-.1a1.6 1.6 0 0 0-1.4 0l-.2.1-16 9.1a1 1 0 0 0 0 1.8l16 9.1.2.1a1.6 1.6 0 0 0 1.4 0l.2-.1 16-9.1a1 1 0 0 0 .5-.9z" />
      <path fill="#0364B8" d="M12 18.3h10.5v9.6H12zM43 8.6V4.2A2.1 2.1 0 0 0 41 2H13.8A2.1 2.1 0 0 0 11.7 4.2v4.4l16.1 4.3z" />
      <path fill="#0078D4" d="M11.7 8.6h10.7v9.7H11.7z" />
      <path fill="#28A8EA" d="M33.1 8.6H22.4v9.7l10.7 9.6h9.6v-9.6z" />
      <path fill="#0078D4" d="M22.4 18.3h10.7v9.6H22.4z" />
      <path fill="#0364B8" d="M22.4 27.9h10.7v9.7H22.4z" />
      <path fill="#14447D" d="M12 27.9h10.4v8.7H12z" />
      <path fill="#0078D4" d="M33.1 27.9h9.6v9.7h-9.6z" />
      <path fill="#1490DF" d="M44.5 25.4 28.1 34.7l-.2.1a1.6 1.6 0 0 1-.7.2l-.9-.5-.1-.1-16.6-9.5A1 1 0 0 0 9 25V44a2 2 0 0 0 2 2h32a1.9 1.9 0 0 0 .5-.1.6.6 0 0 0 .2-.1l.2-.1a1.8 1.8 0 0 0 .4-.2 2.1 2.1 0 0 0 .7-1.6V24.6a1 1 0 0 1-.5.8z" />
      <path fill="#28A8EA" d="M27 45.9H11a2 2 0 0 1-2-2V25l16.6 9.5.1.1.9.5.2-.1 16.4-9.3v18.2a2 2 0 0 1-.6 1.5l-.2.1-.2.1-.5.1z" opacity=".5" />
      <rect width="20" height="20" x="2" y="14" fill="#0078D4" rx="2" />
      <path fill="#fff" d="M7.2 21.3a5 5 0 0 1 2-2.1 6 6 0 0 1 3.1-.8 5.6 5.6 0 0 1 2.9.7 5 5 0 0 1 1.9 2.1 6.7 6.7 0 0 1 .7 3 7 7 0 0 1-.7 3.2 5 5 0 0 1-2 2.1 5.8 5.8 0 0 1-3 .8 5.7 5.7 0 0 1-3-.7 5 5 0 0 1-1.9-2.1 6.6 6.6 0 0 1-.7-3 7.3 7.3 0 0 1 .7-3.2zm2.1 5.2a3.3 3.3 0 0 0 1.1 1.4 2.9 2.9 0 0 0 1.8.5 3 3 0 0 0 1.8-.5 3.2 3.2 0 0 0 1.1-1.4 5.5 5.5 0 0 0 .4-2.1 5.6 5.6 0 0 0-.3-2.1 3.3 3.3 0 0 0-1.1-1.5 3 3 0 0 0-1.8-.6 3 3 0 0 0-1.8.5 3.3 3.3 0 0 0-1.2 1.5 5.7 5.7 0 0 0 0 4.3z" />
    </svg>
  );
}

export function MicrosoftLogo({ className = 'h-4 w-4' }: P) {
  return (
    <svg viewBox="0 0 21 21" className={className} aria-hidden>
      <path fill="#F25022" d="M1 1h9v9H1z" />
      <path fill="#7FBA00" d="M11 1h9v9h-9z" />
      <path fill="#00A4EF" d="M1 11h9v9H1z" />
      <path fill="#FFB900" d="M11 11h9v9h-9z" />
    </svg>
  );
}

export function ICloudLogo({ className = 'h-8 w-8' }: P) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <defs>
        <linearGradient id="icloud-g" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0" stopColor="#3E8BF8" />
          <stop offset="1" stopColor="#1A6BE0" />
        </linearGradient>
      </defs>
      <rect width="48" height="48" rx="11" fill="url(#icloud-g)" />
      <path fill="#fff" d="M35 31.5H15.2a6.2 6.2 0 0 1-.9-12.3 8.6 8.6 0 0 1 16.4-1.6 6.9 6.9 0 0 1 4.3 13.9z" />
    </svg>
  );
}

export function YahooLogo({ className = 'h-8 w-8' }: P) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <rect width="48" height="48" rx="11" fill="#6001D2" />
      <path fill="#fff" d="M9 16.5h5.4l3.1 8 3.2-8H26l-8 19.1h-5.3l2.2-5.1zm22.3 6.4h-5.9l5.2-12.4h5.9zm-4.3 1.6a3.4 3.4 0 1 1 0 6.8 3.4 3.4 0 0 1 0-6.8z" />
    </svg>
  );
}

export function ZohoLogo({ className = 'h-8 w-8' }: P) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <rect width="48" height="48" rx="11" fill="#fff" stroke="#E5E7EB" />
      <rect x="7" y="17" width="8" height="14" rx="1.5" fill="#E42527" transform="rotate(-8 11 24)" />
      <rect x="16" y="17" width="8" height="14" rx="1.5" fill="#089949" transform="rotate(6 20 24)" />
      <rect x="25" y="17" width="8" height="14" rx="1.5" fill="#226DB4" transform="rotate(-6 29 24)" />
      <rect x="34" y="17" width="7" height="14" rx="1.5" fill="#F9B21D" transform="rotate(8 37.5 24)" />
    </svg>
  );
}

export function FastmailLogo({ className = 'h-8 w-8' }: P) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <rect width="48" height="48" rx="11" fill="#0067B9" />
      <path fill="#fff" d="M11 15h26a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V17a2 2 0 0 1 2-2z" opacity=".25" />
      <path fill="#fff" d="m9.8 16.4 14.2 11 14.2-11 1.2 1.6L24 30 8.6 18z" />
      <path fill="#FFC107" d="M30 33h9v2h-9z" />
    </svg>
  );
}

export function AolLogo({ className = 'h-8 w-8' }: P) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <rect width="48" height="48" rx="11" fill="#000" />
      <text x="24" y="29.5" fill="#fff" fontFamily="Arial, Helvetica, sans-serif" fontSize="14" fontWeight="700" textAnchor="middle">Aol.</text>
    </svg>
  );
}

export function OtherMailLogo({ className = 'h-8 w-8' }: P) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden>
      <rect width="48" height="48" rx="11" fill="rgb(var(--primary-soft))" />
      <rect x="11" y="15" width="26" height="18" rx="3" fill="none" stroke="rgb(var(--primary-ink))" strokeWidth="2.4" />
      <path d="m12 17 12 9 12-9" fill="none" stroke="rgb(var(--primary-ink))" strokeWidth="2.4" strokeLinejoin="round" />
    </svg>
  );
}

/** The mark to show for a connected mailbox, chosen by provider and (for IMAP) by the email domain. */
export function providerLogoFor(provider: string, email: string, className = 'h-7 w-7') {
  if (provider === 'gmail') return <GmailLogo className={className} />;
  if (provider === 'outlook') return <OutlookLogo className={className} />;
  const domain = email.split('@')[1]?.toLowerCase() ?? '';
  if (/(^|\.)(icloud|me|mac)\.com$/.test(domain)) return <ICloudLogo className={className} />;
  if (/(^|\.)(yahoo|ymail|rocketmail)\./.test(domain)) return <YahooLogo className={className} />;
  if (/(^|\.)zoho/.test(domain)) return <ZohoLogo className={className} />;
  if (/(^|\.)fastmail/.test(domain)) return <FastmailLogo className={className} />;
  if (/(^|\.)aol\./.test(domain)) return <AolLogo className={className} />;
  return <OtherMailLogo className={className} />;
}
